import {Badge, Button, ButtonGroup, FormCheck, FormControl, FormGroup, FormLabel, FormText} from "react-bootstrap";
import FormCheckLabel from "react-bootstrap/FormCheckLabel";

const FormBase = (props) => {
    const {label, required, className, children} = props;

    return <FormGroup className={className ? className : "mb-4"}>
        <FormLabel>
            {
                required ?
                    <Badge className={"bg-danger me-2"}>必須</Badge> :
                    <Badge className={"bg-secondary me-2"}>任意</Badge>
            }
            {label}
        </FormLabel>
        {children}
    </FormGroup>
}

export const TextForm = (props) => {
    const {
        name,
        label,
        placeholder,
        required,
        register,
        children
    } = props;
    return (
        <FormBase label={label} required={required}>
            <FormControl
                type="text"
                placeholder={placeholder}
                name={name}
                required={required}
                {...register(name, {required: required})}
            />
            {children}
        </FormBase>
    )
}

export const EmailForm = (props) => {
    const {
        name,
        label,
        placeholder,
        required,
        register,
        children
    } = props;
    return (
        <FormBase label={label} required={required}>
            <FormControl
                type="email"
                placeholder={placeholder}
                name={name}
                required={required}
                {...register(name, {required: required})}
            />
            {children}
        </FormBase>
    )
}

export const TelForm = (props) => {
    const {
        name,
        label,
        placeholder,
        required,
        register,
        children
    } = props;
    return (
        <FormBase label={label} required={required}>
            <FormControl
                type="tel"
                placeholder={placeholder}
                name={name}
                required={required}
                {...register(name, {required: required})}
            />
            {children}
        </FormBase>
    )
}

export const TextAreaForm = (props) => {
    const {
        name,
        label,
        placeholder,
        rows,
        cols,
        required,
        register,
        children
    } = props;
    return (
        <FormBase label={label} required={required}>
            <FormControl
                as={"textarea"}
                rows={rows}
                cols={cols}
                placeholder={placeholder}
                name={name}
                required={required}
                {...register(name, {required: required})}
            />
            {children}
        </FormBase>
    )
}

export const RadioForm = (props) => {
    const {
        name,
        label,
        choices,
        required,
        register,
        children
    } = props;
    return (
        <FormBase label={label} required={required}>
            <div className="mb-3">
                {choices.map(({value, display_name}, index) => {

                    return <FormCheckLabel className={"me-3"}>
                        <FormCheck
                            inline={true}
                            type="radio"
                            name={name}
                            required={required}
                            value={value}
                            {...register(name, {required: required})}
                        /> {display_name}
                    </FormCheckLabel>
                })}
            </div>
            {children}
        </FormBase>
    )
}

export const CheckForm = (props) => {
    const {
        name,
        label,
        required,
        register,
        children
    } = props;
    return (
        <FormBase label={label} required={required}>
            <FormCheck
                inline={true}
                type="check"
                name={name}
                required={required}
                {...register(name, {required: required})}
            />
            {children}
        </FormBase>
    )
}

export const SubmitButton = (props) => {
    const {
        message,
        submitStatus
    } = props;
    const Display = () => {
        if (submitStatus === "submitting") {
            return <div className="spinner-border" role="status"/>
        } else if (submitStatus === "success") {
            return <span>ありがとうございます。返信をお待ちください。</span>
        } else {
            return <span>{message}</span>
        }
    }
    const Error = () => {

        if (submitStatus === "ERR_NETWORK") {
            return <p className={"p-3"}>送信に失敗しました。<br/>
                恐れ入りますが、通信状態を確認してください。<br/>
                何度も失敗する場合は、お手数ですが <a href={"mailto:info@34system.com"}>info@34system.com</a>までご連絡いただけると幸いです。
            </p>
        }
        if (submitStatus === "failed") {
            return <p className={"p-3"}>送信に失敗しました。<br/>
                お手数ですが <a href={"mailto:info@34system.com"}>info@34system.com</a>までご連絡いただけると幸いです。
            </p>
        }

        return ""
    }

    return (
        <FormGroup>
            <Button className={"w-100"}
                    type={"submit"}
                    disabled={["submitting", "success"].includes(submitStatus)}
                    style={{
                        backgroundColor: "rgb(27, 204, 169)",
                        borderColor: "rgb(27, 204, 169)",
                        color: "black",

                    }}>
                <Display/>
            </Button>
            <Error/>
        </FormGroup>
    )
}

